import { render, staticRenderFns } from "./businessRulesSwitch.vue?vue&type=template&id=aabc1726&scoped=true&"
import script from "./businessRulesSwitch.vue?vue&type=script&lang=js&"
export * from "./businessRulesSwitch.vue?vue&type=script&lang=js&"
import style0 from "./businessRulesSwitch.vue?vue&type=style&index=0&id=aabc1726&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aabc1726",
  null
  
)

export default component.exports